<template>
  <div class="jchg">
    <headerBanner :bannerUrl='bannerUrl'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i8"></i></div><p>精彩回顾</p>
    </div>
    <div class="listWrap" v-if='plist.length>0'>
      <div class="title">图片集锦</div>
      <div class="jchg_list">

        <div class="item_left" v-for='item in plist'>
          <router-link :to="'/jchg/index/photo/'+item.id">
            <img :src="domain+item.litpic" alt="" class="item_banner">
            <div class="jchg_list_text">
              <img src="../../static/images/icon1.png" alt="" class='icon1'><span><span class="EY_Regular">{{item.title}}</span></span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="listWrap"  v-if='vlist.length>0'>
      <div class="title">视频集锦</div>
      <div class="jchg_list">

        <div class="item_left" v-for='item in vlist'>
          <router-link :to="'/jchg/index/video/'+item.id">
            <img :src="domain+item.litpic" alt="" class="item_banner">
            <div class="jchg_list_text">
              <img src="../../static/images/icon1.png" alt="" class='icon1'><span><span class="EY_Regular">{{item.title}}</span></span>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- <div class="jchg_list">
      <div class="item_left">
        <router-link to="/jchg/index/photo">
          <img src="../../static/images/photo_item.jpg" alt="" class="item_banner">
          <div class="jchg_list_text">
            <img src="../../static/images/icon1.png" alt="" class='icon1'><span><span class="EY_Regular">2019</span>启动仪式</span>
          </div>
        </router-link>
      </div>
      <div class="item_right">
        <div class="item_right_video">
          <router-link to="/jchg/index/video/2">
            <img src="../../static/images/video_item1.jpg" alt="" class="item_banner">
            <div class="jchg_list_text">
              <img src="../../static/images/icon1.png" alt="" class='icon2'><span><span class="EY_Regular">2018</span>获奖企业视频介绍</span>
            </div>
          </router-link>
        </div>
        <div class="item_right_video">
          <router-link to="/jchg/index/video/3">
            <img src="../../static/images/video_item2.jpg" alt="" class="item_banner">
            <div class="jchg_list_text">
              <img src="../../static/images/icon1.png" alt="" class='icon2'><span><span class="EY_Regular">2018</span>颁奖典礼花絮视频</span>
            </div>
          </router-link>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'jchg',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      cate:'',
      bannerUrl:'',
      plist:[],
      vlist:[]
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_plists',
       {
          cid:this.$route.params.id
        },
       {emulateJSON : true})
   .then((response) => {
         this.vlist=response.body.vlist;
         this.plist = response.body.plist;
         this.bannerUrl = this.domain+response.body.bgpic
         console.log(response)
         
     })
  }
}
</script>

<style scoped>
  .title{
    font-size: .24rem;
    padding: 0 .39rem;
    margin-bottom: .2rem;
  }
  .listWrap{
    margin-bottom: .2rem;
  }
  i.i8{
    width: 0.36rem;
    height: 0.4rem;
    background-position: -2.18rem -1.28rem;
  }
  .jchg_list{
    padding: 0 0.39rem;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .item_left{
    float: left;
    width: 2.73rem;
    margin-bottom: .1rem;
  }
  .item_left .item_banner{
    width: 100%;
    box-sizing: border-box;
    border-top: 0.14rem solid #d0d0d0;
    border-left: 0.19rem solid #d0d0d0;
    border-right: 0.19rem solid #d0d0d0;
    display: block;
  }
  .item_right{
    float: right;
    width: 2.73rem;
  }
  .item_right .item_banner{
    width: 100%;
    box-sizing: border-box;
    border-top: 0.14rem solid #d0d0d0;
    border-left: 0.13rem solid #d0d0d0;
    border-right: 0.13rem solid #d0d0d0;
    display: block;
  }
  .jchg_list_text{
    height: 0.35rem;
    line-height: 0.35rem;
    font-size: 0.2rem;
    color: #000000;
    background-color: #ffd200;
    padding: 0 0.06rem;
  }
  .jchg_list_text .icon1{
    width: 0.28rem;
    vertical-align: middle;
    margin-right:0.06rem;
  }
  .jchg_list_text .icon2{
    width: 0.33rem;
    vertical-align: middle;
    margin-right:0.06rem;
  }
  .jchg_list_text>span{
    vertical-align: middle;
  }
  .item_right_video:first-child{
    margin-bottom: 0.15rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/jchg.vue